export enum USER_TYPES {
	CLIENT = 'Client',
	RESELLER = 'Reseller',
	SUB_ACCOUNT = 'SubAccount',
}

export enum USER_NPS_TRIGGER_STATE {
	SHOW_EXPANDED = 'SHOW_EXPANDED',
	SHOW_COLLAPSED = 'SHOW_COLLAPSED',
	HIDE = 'HIDE',
}

export enum EUserReferralUtm {
	UTM_SOURCE = 'utm_source',
	UTM_MEDIUM = 'utm_medium',
	UTM_CAMPAIGN = 'utm_campaign',
	UTM_CONTENT = 'utm_content',
	UTM_TERM = 'utm_term',
}
